import { Component } from 'react';

import moment from 'moment';

import { getInfluencerYoutubeFeeds } from '../../../../../api_handlers/feeds';

import ArrowRightAltIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftAltIcon from '@material-ui/icons/ArrowLeft';

const labelText = {
  fontSize: '11px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '5px',
};

const valueText = {
  fontSize: '11px',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '5px',
};

const arrowStyle = {
  background: '#111936',
  boxShadow: '2px 5px 10px rgba(57, 57, 57, 0.25)',
  marginRight: '10px',
  borderRadius: '50%',
  height: '32px',
  width: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export default class YoutubePostCardMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feeds: [],
      count: 0,
      page: 1,
      loading: false,
      currentIndex: 0,
    };
  }

  ellipsis(text) {
    if (text && text.length > 40) return text.slice(0, 37) + '...';
    return text;
  }

  async reloadData() {
    await this.setState({
      feeds: [],
      count: 0,
      page: 1,
    });
    this.getData();
  }

  async getData() {
    this.setState({
      loading: true,
    });
    const campaignId = this.props.campaignId;
    const influencerId = this.props.influencerId;
    const resp = await getInfluencerYoutubeFeeds(this.state.page, campaignId, influencerId, {
      start_date: this.props.startDate ? moment(this.props.startDate).format('YYYY-MM-DD') : null,
      end_date: this.props.endDate ? moment(this.props.endDate).format('YYYY-MM-DD') : null,
      order_by: this.state.order === 'desc' ? '-' + this.state.orderBy : this.state.orderBy,
    });
    this.setState({
      feeds: this.state.feeds.concat(resp.results),
      count: resp.count,
      loading: false,
    });
  }

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
    setTimeout(() => {
      this.getData(this.state.page);
    }, 30);
  }

  render() {
    let { feeds, currentIndex } = this.state;

    return (
      <div
        style={{
          display: 'flex',
          background: 'white',
          overflow: 'scroll',
          alignItems: 'flex-start',
          height: '420px',
        }}
      >
        <div
          style={{
            background: '#F3F3F3',
            padding: '10px',
            width: '150px',
            margin: '10px',
            borderRadius: '15px',
          }}
        >
          <div style={{ ...labelText, ...{ height: '40px' } }}>Post Name</div>
          <div style={labelText}>Post Type</div>
          <div style={labelText}>User</div>
          <div style={labelText}>Cost Per View</div>
          <div style={labelText}>View</div>
          <div style={labelText}>Likes</div>
          <div style={labelText}>Comments</div>
          <div style={labelText}>Estimated Minutes Watched</div>
          <div style={labelText}>Comments</div>
          <div style={labelText}>Average Duration(s)</div>
          <div style={labelText}>Shares</div>
        </div>
        {feeds && feeds.length > 0 ? (
          <div
            style={{
              padding: '10px',
              flex: 1,
              margin: '10px',
              background: '#FFFFFF',
              border: '2px solid #111936',
              boxShadow: '0px 5px 10px rgba(128, 128, 128, 0.25)',
              borderRadius: '5px',
            }}
          >
            <div style={{ ...valueText, ...{ height: '40px' } }}>
              {this.ellipsis(feeds[currentIndex].title)}
            </div>
            <div style={valueText}>{feeds[currentIndex].post_type}</div>
            <div style={valueText}>{feeds[currentIndex].user_name}</div>
            <div style={valueText}>{feeds[currentIndex].cpv}</div>
            <div style={valueText}>{feeds[currentIndex].cpe}</div>
            <div style={valueText}>{feeds[currentIndex].view_count}</div>
            <div style={valueText}>{feeds[currentIndex].like_count}</div>
            <div style={valueText}>{feeds[currentIndex].comment_count}</div>
            <div style={valueText}>{feeds[currentIndex].estimatedminuteswatched}</div>
            <div style={valueText}>{feeds[currentIndex].averageviewduration}</div>
            <div style={valueText}>{feeds[currentIndex].share_count}</div>
          </div>
        ) : null}
        <div style={{ position: 'absolute', bottom: '50px', right: '15px', display: 'flex' }}>
          {currentIndex > 0 ? (
            <div
              style={arrowStyle}
              onClick={() => {
                let { currentIndex } = this.state;
                if (currentIndex > 0) {
                  currentIndex -= 1;
                }
                this.setState({ currentIndex: currentIndex });
              }}
            >
              <ArrowLeftAltIcon style={{ color: 'white' }} />
            </div>
          ) : null}
          {currentIndex < feeds.length - 1 ? (
            <div
              style={arrowStyle}
              onClick={() => {
                let { feeds, currentIndex, count, loading, page } = this.state;
                if (currentIndex < feeds.length - 1) {
                  currentIndex += 1;
                }
                this.setState({ currentIndex: currentIndex });
                if (feeds.length < count && loading === false && currentIndex % 7 === 0) {
                  page++;
                  this.setState({
                    page: page,
                  });
                  this.getData();
                }
              }}
            >
              <ArrowRightAltIcon style={{ color: 'white' }} />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
